export default "__VITE_ASSET__Chstz9zV__"